import { z } from 'zod';

import { LocationId } from './Location';

export const CampaignId = z.string().brand('CampaignId');
const campaignHashTag = z.custom<`campaign:${string}`>((val) => {
  return /^campaign:\w+$/.test(val as string);
});
export const Campaign = z.object({
  id: CampaignId,
  locationId: LocationId,
  name: z.string(),
  hashTag: campaignHashTag,
  description: z.string(),
  eyeCatchURL: z.string().url(),
  bannerURL: z.string().url().optional(),
  draft: z.boolean(),
  startDate: z.string().datetime({ offset: true }),
  endDate: z.string().datetime({ offset: true }),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
  publishedAt: z.string().datetime({ offset: true }),
});
export type CampaignType = z.infer<typeof Campaign>;
